import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import rightIcon from "@iconify/icons-mdi/chevron-right";
import documentIcon from "@iconify/icons-mdi/file-document";
import { InlineIcon } from "@iconify/react";
import useSelectedTaxDeclaration from "my-tax/hooks/use-selected-tax-declaration";
import useTaxApplications from "my-tax/hooks/use-tax-applications";
import { useOcIsMobile } from "oc/hooks/use-is-mobile";

interface MyTaxApplicationSelectorProps {
  label: string;
  type: string;
}

export const MyTaxApplicationSelector = ({ label, type }: MyTaxApplicationSelectorProps) => {
  const theme = useTheme();
  const isMobile = useOcIsMobile();

  const { selected, setSelected } = useSelectedTaxDeclaration();

  const { taxApplications } = useTaxApplications();
  const enabled = taxApplications[type];

  const handleClick = () => {
    if (!enabled) return;
    const newState = { ...selected, editable: true, type };
    setSelected(newState);
  };

  const modifiedLabel = label?.replaceAll(/[áéíóöőúüűÁÉÍÓÖŐÚÜŰ]/g, (match) => {
    const characherCorrection = {
      á: "a",
      é: "e",
      í: "i",
      ó: "o",
      ö: "o",
      ő: "o",
      ú: "u",
      ü: "u",
      ű: "u",
      Á: "A",
      É: "E",
      Í: "I",
      Ó: "O",
      Ö: "O",
      Ő: "O",
      Ú: "U",
      Ü: "U",
      Ű: "U",
    };
    return characherCorrection[match as keyof typeof characherCorrection];
  });

  return (
    <Box
      id={modifiedLabel?.replaceAll(/\s+/g, "")}
      height={isMobile ? "100%" : "72px"}
      display="flex"
      flexDirection="row"
      alignItems="center"
      onClick={handleClick}
      style={{
        backgroundColor: theme.palette.gray20.main,
        border: `1px solid ${theme.palette.gray40.main}`,
        display: "flex",
        borderRadius: "8px",
        color: enabled
          ? theme.palette.darkBase.main
          : theme.palette.gray60.main,
        cursor: enabled ? "pointer" : "unset",
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="40px"
        height="40px"
        marginLeft="7px"
      >
        <InlineIcon icon={documentIcon} width="20px" height="20px" />
      </Box>
      {isMobile && <Box width="16px" />}
      <Box
        flexGrow={1}
        display="flex"
        flexDirection="column"
        padding={isMobile ? "16px 0px" : "unset"}
      >
        <Typography
          variant="body1"
          style={
            enabled
              ? { color: theme.palette.darkBase.main }
              : { color: theme.palette.gray60.main }
          }
        >
          {label}
        </Typography>
      </Box>
      <Box width="10px" />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="40px"
        height="40px"
        style={{
          marginRight: "10px",
        }}
      >
        <InlineIcon
          icon={rightIcon}
          width="18px"
          height="18px"
          style={
            enabled
              ? { color: theme.palette.darkBase.main }
              : { color: theme.palette.gray60.main }
          }
        />
      </Box>
    </Box>
  );
};

export default MyTaxApplicationSelector;
